// @ts-check
// Regras puras dos endereços e da guarda do menu Campanhas (spec-2.0.0 seção 4.10, [BASE 2.5 e 2.6]; contrato 09 de
// campanhas base), usadas pelas telas e pelos testes.
import { CAMPAIGN_SCREENS, canOpenScreenLink } from '../../../shared/navigation/screen-access.js';

/**
 * Endereço novo de um link antigo /campaigns/<id> (campanha de e-mail da 1.13.0), mantendo a busca e a âncora.
 * @param {string} campaignId @param {{ search?: string, hash?: string }} [location]
 */
export function legacyEmailCampaignPath(campaignId, { search = '', hash = '' } = {}) {
  return `/campaigns/email/${encodeURIComponent(campaignId)}${search}${hash}`;
}

/**
 * O papel abre a tela de campanha? Precisa da flag da tela e de ler o card, que é o público das campanhas e dos fluxos.
 * @param {import('../../../shared/navigation/screen-access.js').CampaignScreenKey | 'home'} screenKey
 * @param {(flag: string) => boolean} hasPermissionFlag @param {boolean} canReadCards
 */
export function canOpenCampaignScreen(screenKey, hasPermissionFlag, canReadCards) {
  const path = CAMPAIGN_SCREENS.find((screen) => screen.key === screenKey)?.path ?? '/campaigns';
  return canReadCards && canOpenScreenLink(path, hasPermissionFlag);
}
